export default "__VITE_ASSET__a57d83ab__"